var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sip-view-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm sip-view-head" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("locale.translation"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nk-block-des text-soft" }, [
            _c("p", [
              _vm._v(
                _vm._s(_vm.trans("locale.locale")) +
                  " · " +
                  _vm._s(_vm.getName(_vm.module))
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "locale" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c(
            "div",
            {
              staticClass:
                "admin-config-panel__inner admin-config-panel__inner--wide sip-view-card",
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-3 mb-3 mb-lg-0" }, [
                  _c(
                    "nav",
                    {
                      staticClass: "admin-config-module-nav",
                      attrs: { "aria-label": _vm.trans("locale.module") },
                    },
                    _vm._l(_vm.modules, function (mdl) {
                      return _c(
                        "router-link",
                        {
                          key: mdl,
                          staticClass: "admin-config-module-nav__link",
                          class: {
                            "admin-config-module-nav__link--active":
                              mdl === _vm.module,
                          },
                          attrs: { to: _vm.getModuleLink(mdl), exact: "" },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.getName(mdl)) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-9" },
                  [
                    _c("show-tip", {
                      attrs: { module: "locale", tip: "tip_translation" },
                    }),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "sip-view-section",
                        attrs: {
                          "aria-label": _vm.trans("locale.translation"),
                        },
                      },
                      [
                        _vm.getWordCount
                          ? _c(
                              "div",
                              [
                                _vm._l(_vm.words, function (word, index) {
                                  return _c("div", { key: index }, [
                                    typeof word === "object"
                                      ? _c(
                                          "div",
                                          _vm._l(word, function (wrd, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: `${index}_${i}`,
                                                staticClass: "form-group",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          _vm.module +
                                                            "." +
                                                            index +
                                                            "." +
                                                            i
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.words[index][i],
                                                      expression:
                                                        "words[index][i]",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    value: "",
                                                    name: `${index}_${i}`,
                                                  },
                                                  domProps: {
                                                    value: _vm.words[index][i],
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.words[index],
                                                        i,
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      _vm.module + "." + index
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.words[index],
                                                  expression: "words[index]",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                value: "",
                                                name: index,
                                              },
                                              domProps: {
                                                value: _vm.words[index],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.words,
                                                    index,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                  ])
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "admin-config-actions" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                                        attrs: { type: "button" },
                                        on: { click: _vm.saveTranslation },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.trans("general.save"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _c("div", [
                              _c("p", { staticClass: "sip-view-note mb-0" }, [
                                _vm._v(
                                  _vm._s(_vm.trans("general.no_result_found"))
                                ),
                              ]),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }